import React from 'react';
import { 
  X, 
  LayoutDashboard, 
  Package, 
  MapPin, 
  FileText, 
  User, 
  Lock, 
  LogOut
} from 'lucide-react';

const AccountMobileMenu = ({ activeTab, setActiveTab, isOpen, setIsOpen, onLogout, profile }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'orders', label: 'My Orders', icon: Package },
    { id: 'addresses', label: 'Saved Addresses', icon: MapPin },
    { id: 'bills', label: 'Bills', icon: FileText },
    { id: 'profile', label: 'Profile Information', icon: User },
    { id: 'security', label: 'Security', icon: Lock }
  ];

  const handleItemClick = (tabId) => {
    setActiveTab(tabId);
    setIsOpen(false);
  };

  const getInitials = (fullName) => {
    if (!fullName) return '';
    const parts = fullName.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  return (
    <>
      {/* Drawer Overlay */}
      {isOpen && <div className="drawer-overlay" onClick={() => setIsOpen(false)} />}

      {/* Slide-out Drawer Menu */}
      <div className={`account-mobile-drawer ${isOpen ? 'open' : ''}`}>
        <button onClick={() => setIsOpen(false)} className="drawer-close-btn" title="Close Menu">
          <X size={24} />
        </button>

        {/* Profile Info inside Drawer */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 0 20px', borderBottom: '1px solid #27272a', marginBottom: '20px' }}>
          <div style={{
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '18px',
            fontWeight: 700,
            color: '#000',
            overflow: 'hidden'
          }}>
            {profile?.avatar ? (
              <img src={profile.avatar} alt={profile.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              <span>{getInitials(profile?.name) || 'U'}</span>
            )}
          </div>
          <div>
            <h4 style={{ color: 'var(--color-text-primary)', fontSize: '15px', fontWeight: 600, margin: 0 }}>{profile?.name || 'User'}</h4>
            <span style={{ color: 'var(--color-text-secondary)', fontSize: '12px' }}>{profile?.email}</span>
          </div>
        </div>

        {/* Navigation Items */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', flexGrow: 1 }}>
          {menuItems.map(item => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                onClick={() => handleItemClick(item.id)}
                className={`sidebar-nav-item ${activeTab === item.id ? 'active' : ''}`}
              >
                <Icon size={18} />
                <span>{item.label}</span>
              </button>
            );
          })}
          <button
            onClick={() => {
              setIsOpen(false);
              onLogout();
            }}
            className="sidebar-nav-item logout-btn"
          >
            <LogOut size={18} style={{ color: '#ef4444' }} />
            <span style={{ color: '#ef4444' }}>Logout</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default AccountMobileMenu;
